const isLocal = false;
const protocol = isLocal ? 'http' : 'https';
const port = isLocal ? ':4000' : '';
const hostName = isLocal ? 'localhost' : location.hostname;
export default {
    apiUrl: `${protocol}://${hostName}${port}/graphql` //    https://digitalcards.calzedonia.com/graphql
};